<template>
  <input 
    type="checkbox" 
    class="btn-check" 
    :id="option" 
    :value="option"
    v-model="checkboxValue"
  >
  <label
    class="btn btn-outline-primary" 
    :for="option"
  >
    {{ option }}
  </label>
</template>
<script>
export default {
  props: {
    value: Array,
    option: String
  },
  computed: {
    checkboxValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
<style scoped>
  
</style>